import { useReducer, useEffect, useState } from 'react';
import { Question, TriviaContextTypes, responseValidateQuestion } from '../../interfaces';
import { TriviaContext, triviaReducer } from './';

export interface TriviaState {
  questions: Question[];
  activeQuestion: Question | null;
  missingResponse: boolean;
  isLoadTrivia: boolean;
  isOpenTrivia: boolean;
  result: responseValidateQuestion[] | null;
  triviaId: number | null;
}

const Trivia_INITIAL_STATE: TriviaState = {
  questions: [],
  activeQuestion: null,
  missingResponse: false,
  isLoadTrivia: false,
  result: null,
  isOpenTrivia: false,
  triviaId: null
};

type TriviaProviderProps = {
  children: JSX.Element[] | JSX.Element;
};

export const TriviaProvider = ({ children }: TriviaProviderProps) => {
  const [state, dispatch] = useReducer(triviaReducer, Trivia_INITIAL_STATE);

  /* ==========================
    CRONÓMETRO
  ========================== */
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [timerRunning, setTimerRunning] = useState(false);
  const [attempt, setAttempt] = useState(1);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (timerRunning) {
      interval = setInterval(() => {
        setTimeElapsed(prev => prev + 1);
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [timerRunning]);

  /* ==========================
     Métodos existentes
  ========================== */

  const setTrivia = (questions: Question[]) => {
    dispatch({ type: TriviaContextTypes.SET_TRIVIA, payload: questions });
  };

  const setCurrentQuestion = (question: Question) => {
    dispatch({ type: TriviaContextTypes.SET_ACTIVE_QUESTION, payload: question });
  };

  const setTriviaId = (id: number) => {
    dispatch({ type: TriviaContextTypes.SET_TRIVIA_ID, payload: id });
  };

  const selectQuestion = (question: Question, responseId: string) => {
    dispatch({
      type: TriviaContextTypes.SELECT_OPTION_QUESTION,
      payload: {
        question,
        response: responseId
      }
    });
  };

  const setMissingResponse = (newStatus: boolean) => {
    dispatch({
      type: TriviaContextTypes.SET_MISSING_RESPONSE,
      payload: newStatus
    });
  };

  const saveResponseTrivia = (response: responseValidateQuestion[]) => {
    dispatch({
      type: TriviaContextTypes.SET_RESPONSE,
      payload: response
    });
  };

  const setLoadTrivia = () => {
    dispatch({ type: TriviaContextTypes.SET_LOAD_TRIVIA });
  };

  const onOpenTrivia = () => {
    dispatch({ type: TriviaContextTypes.SET_OPEN_TRIVIA });
  };

  const onCloseAndClearTrivia = () => {
    // limpiar cronómetro
    setTimerRunning(false);
    setTimeElapsed(0);

    dispatch({ type: TriviaContextTypes.CLOSE_AND_CLEAR });
  };

  const incrementAttempt = () => {
    setAttempt(prev => prev + 1);
  };

  const resetAttempt = () => {
    setAttempt(0);
  };

  const retryTriviaState = () => {
    dispatch({ type: TriviaContextTypes.RETRY_TRIVIA });
  };

  return (
    <TriviaContext.Provider
      value={{
        ...state,

        // tiempo compartido
        timeElapsed,
        timerRunning,
        setTimeElapsed,
        setTimerRunning,

        // métodos existentes
        setTrivia,
        setTriviaId,
        setCurrentQuestion,
        selectQuestion,
        setMissingResponse,
        saveResponseTrivia,
        setLoadTrivia,
        onOpenTrivia,
        onCloseAndClearTrivia,
        incrementAttempt,
        resetAttempt,
        attempt,
        retryTriviaState
      }}
    >
      {children}
    </TriviaContext.Provider>
  );
};
